/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 -t --transform Games.glb 
Files: Games.glb [11.21KB] > C:\Users\fedde\Downloads\Games-transformed.glb [11.14KB] (1%)
*/

import { useRef } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { Icon, IconProps } from "../../components/Icon";
import { Mesh, MeshStandardMaterial, Vector3 } from "three";
import { CalloutProps } from "../../components/Callout";

type GLTFResult = GLTF & {
  nodes: {
    WebExp_Games: Mesh;
  };
  materials: { [name: string]: MeshStandardMaterial };
};

export function Games(props: JSX.IntrinsicElements["group"]) {
  const calloutProps: CalloutProps = {
    graphicTexturePath: "/images/IconGraphic.png",
    graphicGlb: "/models/Callout/CalloutPlanev02.glb",
    graphicLocation: new Vector3(-0.59, -0.1, 1.1),
    textTitle: "Games",
    textTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textTitleColor: "#ffffff",
    textTitleFontSize: 0.4,
    textTitlePosition: new Vector3(-0.6, 0, 1),
    textSubTitle: "Play",
    textSubTitleFontSize: 0.2,
    textSubTitleFont: "/fonts/bebas-neue-v9-latin-regular.woff",
    textSubTitleColor: "#00EAFF",
    textSubTitlePosition: new Vector3(-0.61, -0.4, 1.21),
    scaleSpeed: 5,
    pivotPoint: new Vector3(42.4614, -4.04931, 29.8962),
    active: false,
  };
  const iconProps: IconProps = {
    name: "Games",
    blenderPosition: new Vector3(
      42.46143341064453,
      -29.896215438842773,
      4.049307346343994
    ),
    idleRotationSpeed: 0.5,
    hoverTranslateY: 5,
    hoverLookAtFactor: 5,
    selectorDimensions: [8, 12, 8],
    paddingLeaveDimensions: [20, 20, 20],
    hoverRotationY: 4,
    cameraPositionSelected: new Vector3(42.4614, -4.04931, 69.8962),
    cameraTargetSelected: new Vector3(42.4614, -4.04931, 29.8962),
    calloutProps: calloutProps,
  };

  //REFS
  const gamesRef = useRef(null);
  const { nodes } = useGLTF("/models/Games-transformed.glb") as GLTFResult;
  return (
    <Icon
      name={iconProps.name}
      blenderPosition={iconProps.blenderPosition}
      idleRotationSpeed={iconProps.idleRotationSpeed}
      hoverTranslateY={iconProps.hoverTranslateY}
      hoverLookAtFactor={iconProps.hoverLookAtFactor}
      selectorDimensions={iconProps.selectorDimensions}
      paddingLeaveDimensions={iconProps.paddingLeaveDimensions}
      hoverRotationY={iconProps.hoverRotationY}
      cameraPositionSelected={iconProps.cameraPositionSelected}
      cameraTargetSelected={iconProps.cameraTargetSelected}
      calloutProps={calloutProps}
    >
      <group ref={gamesRef} {...props} dispose={null}>
        <mesh
          geometry={nodes.WebExp_Games.geometry}
          material={nodes.WebExp_Games.material}
          rotation={[Math.PI, -0.875, Math.PI]}
        />
      </group>
    </Icon>
  );
}

useGLTF.preload("/models/Games-transformed.glb");
